// Global gate for LivingImage: at most `MAX` videos may hold a decode slot
// at any moment. Members register themselves with a live "score" (distance
// from the viewport centre — lower is better). The registry picks the three
// best scores and grants them play; everyone else pauses and reads the still.
// The order of arrival does not matter — only the score.

// Concurrent decode grants. Six is the sweet spot: enough to cover a
// section transition where two vertical grids overlap the viewport (e.g.
// Selected Work's bottom tiles co-visible with HorizontalBand's leftmost
// tile), but tight enough that any given moment only decodes a handful
// of clips. Off-viewport tiles report Infinity and drop out automatically.
const MAX = 6;
const listeners = new Set(); // callback fires when a member's grant flips
const scores = new Map();    // id -> number (viewport-centre distance)

let heroDone = false;
let heroFallbackTimer = null;

export function markHeroDone() {
  if (heroDone) return;
  heroDone = true;
  if (heroFallbackTimer) {
    clearTimeout(heroFallbackTimer);
    heroFallbackTimer = null;
  }
  publish();
}
export function isHeroDone() {
  return heroDone;
}
// Safety net — if the hero's first canplay never fires (autoplay blocked,
// codec probe stalled, mobile Safari heuristic), unstick everything after
// a fixed grace period so LivingImage still comes alive on scroll.
if (typeof window !== "undefined") {
  heroFallbackTimer = setTimeout(() => markHeroDone(), 3500);
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function publish() {
  listeners.forEach((f) => f());
}

export function registerMember(id) {
  if (!scores.has(id)) scores.set(id, Infinity);
}

export function unregisterMember(id) {
  scores.delete(id);
  publish();
}

export function reportScore(id, score) {
  scores.set(id, score);
  publish();
}

// Which members currently hold a play grant?
export function grantedSet() {
  const entries = [...scores.entries()].filter(([, v]) => Number.isFinite(v));
  entries.sort((a, b) => a[1] - b[1]);
  return new Set(entries.slice(0, MAX).map(([k]) => k));
}
